<template>
  <div class="contact">
    <header-info activeName='/contact'></header-info>
    <div class="detail">
      <section class='img'>
        <img src="@/assets/img/contact/banner.png" alt />
      </section>
      <!-- <section class='introduce'>
        <div class='up'>
          <div class='upimg'>
            <img src="@/assets/img/contact/team.png" alt />
          </div>
          <div class='team'>
            <div class='title'>研究团队</div>
            <div class='teamdown'>北京腾景大数据应用科技研究院，简称“腾景数研”，是适应数字时代特点和要求，旨在推动宏观和产业经济研究方法变革、推动数字技术与实体经济深度融合的民办非企业新型研究机构，为中国发展研究基金会“博智宏观论坛”提供学术研究和数据支持。</div>
          </div>
        </div>
        <div class='down'>
          <p class='tip'>研究院学术委员会由目前中国学术研究水准和社会影响力居前的经济学家和有关方面负责人组成，为研究院的研究工作提供指导</p>
          <p class='tip'>研究团队从事中国宏观经济和产业发展的研究已有近二十年时间，对中国改革开放和经济发展提出了一系列具有预见性的重要判断和观点。</p>
          <div class='downimg'>
            <img src="@/assets/img/contact/bozhi.png" alt />
          </div>
        </div>
      </section> -->
      <section class='timeline'>
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :color="activity.color"
            :size="activity.size"
            :timestamp="activity.timestamp"
            placement="top">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
      </section>
      <section class='core'>
        <p class='coreleft'>
          最近几年，研究团队潜心研究、艰苦攻关，形成了集“GFP驱动的宏观经济理论框架+动态化实时化投入产出分析体系（MDEMS）+大数据、人工智能与经济金融领域高度融合的前沿算法”三位一体的核心研究成果，并提出“生态元核算和应用体系”，在推动绿色青山转化为金山银山方面取得开创性成果，在数字金融、绿色金融领域也有重要进展
        </p>
        <div class='coreright'>
          <div class='coreimg'>
            <img src="@/assets/img/contact/core1.png" alt />
          </div>
          <div class='coreimg'>
            <img src="@/assets/img/contact/core2.png" alt />
          </div>
          <!-- <el-card class="box-card">
            <div class='coreimg'>
              <img src="@/assets/img/contact/bozhi.png" alt />
            </div>
            <div class='coretitle'>核心能力一</div>
            <div class='coreinfo'>采用深度学习等人工智能技术进行预测和高频模拟</div>
          </el-card>
          <el-card class="box-card">
            <div class='coreimg'>2</div>
            <div class='coretitle'>核心能力二</div>
            <div class='coreinfo'>投入产出体系的动态化、实时化，开发出“多维动态均衡矩阵系统（MDEMS）</div>
          </el-card> -->
        </div>
      </section>
      <section class='result'>
        <h3 class='restitle'>重要应用成果</h3>
        <div class='resimgs'>
          <div class='imgbox' v-for="item in imgList" :key='item.id'>
            <img :src="item.src" alt />
          </div>
        </div>
        <div class='resimgs'>
          <div class='imgbox-down' v-for="item in imgListDown" :key='item.id'>
            <img :src="item.src" alt />
          </div>
        </div>
      </section>
      <section class='contact-info'>
        <div class='infotitle'>
          <div class='titlerow'>
            我们正处在机器学习、深度学习、强化学习等人工智能技术与
          </div>
          <div class='titlerow'>
            金融经济垂直领域深度融合新风口的领跑区，力争成为
          </div>
        </div>
        <div class='infocard'>
          <el-card class="box-card">
            <div class='coreimg'>
              <img src="@/assets/img/contact/01.png" alt />
            </div>
            <div class='coreinfo'>研发创新导向、市场驱动、与数字化时代相适应的新型研发型组织</div>
          </el-card>
          <el-card class="box-card">
            <div class='coreimg'>
              <img src="@/assets/img/contact/ai.png" alt />
            </div>
            <div class='coreinfo'>人工智能与经济金融深度融合的开拓者、领先者</div>
          </el-card>
          <el-card class="box-card">
            <div class='coreimg'>
              <img src="@/assets/img/contact/leader.png" alt />
            </div>
            <div class='coreinfo'>相关应用领域解决方案有头部竞争力的提供者</div>
          </el-card>
        </div>
        <div class='infotip'>
          您的见识、理解、合作、支持对我们很重要，我们在一条船上
        </div>
        <div class='myinfo'>
          <div class='mytitle'>
            联系方式
          </div>
          <div class='mydetail'>
            <div class='infobox'>
              <div class='info-icon'>
                <img src="@/assets/img/contact/address.png" alt />
              </div>
              <div class='info-down'>
                <div class='text'>
                  北京市朝阳区朝阳门外大街乙6号
                </div>
                <div class='text'>
                  朝外SOHO-A座29层
                </div>
              </div>
            </div>
            <div class='infobox'>
              <div class='info-icon'>
                <img src="@/assets/img/contact/tel.png" alt />
              </div>
              <div class='info-down'>
                15210925572
              </div>
            </div>
            <div class='infobox'>
              <div class='info-icon'>
                <img src="@/assets/img/contact/email.png" alt />
              </div>
              <div class='info-down'>
                EMAIL: TengjingAI@tjresearch.com
              </div>
            </div>
          </div>
          <div class='mymap'>
            <img src="@/assets/img/contact/map.png" alt />
          </div>
          <div class='myother'>
            <div class='code'>
              <div class='code-box'>
                <div class='boxleft'>
                  <img src="@/assets/img/contact/code1.png" alt />
                </div>
                <div class='boxright'>
                  扫码关注微信公众号
                </div>
              </div>
              <div class='code-box'>
                <div class='boxleft'>
                  <img src="@/assets/img/contact/code2.png" alt />
                </div>
                <div class='boxright'>
                  扫一扫添加客服微信
                </div>
              </div>
            </div>
            <div class='more'>
              <div class='moreup'>
                <div>获取更多咨询</div>
                <div>请留下您的联系方式</div>
              </div>
              <div class='moredown'>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" :inline="true">
                  <el-form-item prop="name">
                    <el-input v-model="ruleForm.name" placeholder="姓名"></el-input>
                  </el-form-item>
                  <el-form-item prop="phone">
                    <el-input v-model="ruleForm.phone" placeholder="手机号码"></el-input>
                  </el-form-item>
                  <div class="email-row">
                    <el-form-item prop="mail">
                      <el-input v-model="ruleForm.mail" placeholder="邮箱"></el-input>
                    </el-form-item>
                  </div>
                  <div class="desc-row">
                    <el-form-item prop="message">
                      <el-input type="textarea" v-model="ruleForm.message" :rows="5" placeholder="留言......" resize='none' maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                  </div>
                  <div class="btns">
                    <el-form-item>
                      <el-button @click="submitForm('ruleForm')" style="color:#fff;background:#ff8e5c;border-color:#fff">提交</el-button>
                      <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <footer-info></footer-info>
  </div>
</template>

<script>
import headerInfo from "@/pages/layout/header.vue";
import footerInfo from "@/pages/layout/footer.vue";
import { handleSubmit } from "@/api/contact";
export default {
  components: {
    headerInfo,
    footerInfo
  },
  data() {
    var validateTel = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!myreg.test(value)) {
        callback(new Error("请正确输入手机号"));
      }
      callback();
    };
    return {
      activities: [{
        content: '2009年，提出了中国经济在经历了30年的高速增长后，将会下一个大的台阶，进入中速增长阶段',
        timestamp: '2009年',
        size: 'large',
        color: '#2cab20',
      }, {
        content: '2013年初，提出中国经济增长将会进入与以往大不相同的“新常态”，在增长速度放缓的同时，将会出现经济结构、增长动力和发展方式的系统性转换',
        timestamp: '2013年',
        color: '#2cab20',
        size: 'large'
      }, {
        content: '2016年初 ，提出中国经济需求侧和供给侧已经或接近底部，将进入一个触底验证期，并逐步转入中速稳定增长平台，而不可能出现大的反弹',
        timestamp: '2016年',
        color: '#2cab20',
        size: 'large'
      }, {
        content: '这些具有方向性或转折意义的重要判断，都得到了实际增长进程的证实，对政府决策和社会各界产生了很大影响。目前开发的腾景国民经济运行全口径数据库，又将研究工作推向新的高度',
        timestamp: '至今',
        color: '#2cab20',
        size: 'large'
      }],
      imgList: [
        {
          id: '1',
          src: require("@/assets/img/contact/img1.png")
        },
        {
          id: '2',
          src: require("@/assets/img/contact/img2.png")
        },
        {
          id: '3',
          src: require("@/assets/img/contact/img3.png")
        },
        {
          id: '4',
          src: require("@/assets/img/contact/img4.png")
        },
        {
          id: '5',
          src: require("@/assets/img/contact/img5.png")
        },
        {
          id: '6',
          src: require("@/assets/img/contact/img6.png")
        },
      ],
      imgListDown: [
        {
          id: '1',
          src: require("@/assets/img/contact/img7.png")
        },
        {
          id: '2',
          src: require("@/assets/img/contact/img8.png")
        },
        {
          id: '3',
          src: require("@/assets/img/contact/img9.png")
        },
        {
          id: '4',
          src: require("@/assets/img/contact/img10.png")
        },
      ],
      ruleForm: {
        name: '',
        phone: '',
        mail: '',
        message: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, validator: validateTel , trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let {data} = await handleSubmit(this.ruleForm);
          if(data.resultCode == 200) {
            this.$message.success("提交成功");
            this.ruleForm = {}
          } else {
            this.$message.error("提交失败");
            return false;
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  flex-direction: column;
  // height: 100vh;
  overflow: hidden;
  .detail {
    flex: 1;
    background: #fff;
    // overflow-y: scroll;
    img {
      width: 100%;
      height: 100%;
    }
    .img {
      height: 450px;
      background-color: #1f2531;
    }
    .introduce {
      height: 650px;
      padding: 80px 500px;
      .up {
        display: flex;
        .upimg {
          flex: 1;
          height: 220px;
          background-color: #1f2531;
          margin-right: 50px;
        }
        .team {
          flex: 1;
          .title {
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 50px;
          }
        }
      }
      .down {
        padding: 50px 30px 30px;
        .tip {
          padding: 10px 150px;
        }
        .downimg {
          height: 260px;
          background-color: #1f2531;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .timeline {
      height: 520px;
      padding: 100px 500px 0;
      margin-top: 50px;
      background: #f7f7f7;
      .el-timeline-item {
        padding-bottom: 100px;
      }
      /deep/ .el-timeline-item__timestamp.is-top {
        position: absolute;
        left: -80px;
        top: -3px;
        font-size: 16px;
        font-weight: 500;
        color: #343434;
      }
      .el-timeline-item:last-child /deep/ .el-timeline-item__timestamp.is-top {
        position: absolute;
        left: -70px;
        top: -3px;
      }
    }
    .core {
      height: 300px;
      padding: 80px 500px;
      display: flex;
      .coreleft {
        flex: 1;
        font-size: 14px;
        line-height: 24px;
        padding-top: 50px;
        margin-right: 60px;
      }
      .coreright {
        flex: 1;
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        .coreimg {
          width: 200px;
          height: 190px;
        }
        // .box-card {
        //   width: 180px;
        //   height: 200px;
        //   margin-right: 30px;
        //   .coreimg {
        //     width: 60px;
        //     height: 50px;
        //   }
        //   .coretitle {
        //     color: #ff9a6e;
        //     text-align: center;
        //     margin: 20px 0 10px;
        //   }
        //   .coreinfo {
        //     font-size: 12px;
        //     color: #9b9b9b;
        //     padding: 0 10px;
        //     text-align: center;
        //   }
        // }
      }
    }
    .result {
      height: 780px;
      background: #f7f7f7;
      padding: 50px 500px;
      .restitle {
        text-align: center;
        margin-bottom: 50px;
      }
      .resimgs {
        display: flex;
        flex-wrap: wrap;
        .imgbox {
          width: 31%;
          height: 190px;
          margin-right: 20px;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .imgbox:nth-child(3n) {
          margin-right: 0;
        }
        .imgbox-down {
          width: 22.7%;
          height: 190px;
          margin-right: 20px;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .imgbox-down:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
    .contact-info {
      height: 1600px;
      padding-top: 80px;
      background: url('../../assets/img/contact/bg.png') no-repeat;
      background-size: contain;
      .infotitle {
        margin-top: 100px;
        .titlerow {
          text-align: center;
          color: #fff;
          font-size: 20px;
        }
      }
      .infocard {
        display: flex;
        margin-top: 60px;
        margin-left: 120px;
        padding: 80px 500px;
        .box-card {
          width: 180px;
          height: 200px;
          margin-right: 50px;
          .coreimg {
            width: 50px;
            height: 50px;
            margin: 20px 44px;
          }
          .coreinfo {
            font-size: 12px;
            padding: 0 8px;
            margin-top: 30px;
            text-align: center;
          }
        }
      }
      .infotip {
        font-weight: 700;
        text-align: center;
        margin-bottom: 60px;
      }
      .myinfo {
        .mytitle {
          text-align: center;
          font-size: 18px;
          font-weight: 700;
        }
        .mydetail {
          padding: 0px 650px;
          margin: 30px 0;
          display: flex;
          .infobox {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            .info-icon {
              width: 50px;
              height: 50px;
            }
            .info-down {
              margin-top: 20px;
              font-size: 12px;
              .text {
                text-align: center;
              }
            }
          }
        }
        .mymap {
          height: 350px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .myother {
          height: 350px;
          padding: 60px 550px;
          display: flex;
          justify-content: space-around;
          .code {
            flex: 2;
            .code-box {
              display: flex;
              margin-bottom: 40px;
              .boxleft {
                width: 130px;
                height: 130px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .boxright {
                color: #7a7a7a;
                padding-left: 10px;
                line-height: 100px;
              }
            }
          }
          .more {
            flex: 3;
            .moreup {
              color: #aeaeae;
              font-size: 18px;
              margin-bottom: 20px;
            }
            .moredown {
              .el-form-item {
                margin-bottom: 0;
              }
              /deep/ .el-form-item__content {
                margin-left: 0!important;
                line-height: 24px;
                margin-bottom: 14px;
                color: #000;
              }
              /deep/ .el-input__inner {
                height: 24px;
                line-height: 24px;
                font-size: 12px;
              }
              /deep/ .el-form-item__error {
                padding-top: 0;
              }
              .email-row {
                /deep/ .el-input__inner {
                  width: 205%;
                }
              }
              .desc-row {
                /deep/ .el-textarea__inner {
                  width: 214%;
                  font-family: 微软雅黑;
                  font-size: 12px;
                }
                .el-textarea /deep/ .el-input__count {
                  right: -108%;
                }
                .el-form-item {
                  margin-bottom: 6px;
                }
                /deep/ .el-form-item__error {
                  padding-top: 2px;
                }
              }
              .btns {
                padding-left: 44%;
                .el-button {
                  line-height: 0;
                  font-size: 12px;
                  width: 70px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
